import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueClipboard from 'vue-clipboard2'
import { getCredentials } from './api/conection'
import axios from 'axios'
import VueExcelXlsx from "vue-excel-xlsx";
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import JsonExcel from 'vue-json-excel'

Vue.component('downloadExcel', JsonExcel)



//import PerfectScrollbar from 'vue2-perfect-scrollbar'
//import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css' 


import ApiService from './services/api.service'
import { TokenService } from './services/storage.service'
//import { debug } from 'webpack'
//import PerfectScrollbar from 'vue2-perfect-scrollbar'

//import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css' 




//Vue.use(PerfectScrollbar)
Vue.config.productionTip = false
    // Install BootstrapVue
Vue.use(BootstrapVue)
    // Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(VueClipboard)
Vue.use(VueExcelXlsx)
    // name is optional
Vue.use(VueLodash, { name: 'custom', lodash: lodash })

// Set the base URL of the API
ApiService.init(process.env.VUE_APP_ROOT_API)

// If token exists set header
if (TokenService.getToken()) {
    //debugger;
    ApiService.setHeader()
}

new Vue({

    router,
    store,
    data() {
        return {
            info: null,
            loading: true,
            errored: false
        }
    },
    mounted() {
        //debugger;
        getCredentials()
            .then((result) => {
                //debugger;
                !result.perfil ? router.push("/Login") : 0
            }).catch((e) => { console.log(e) })
    },
    render: h => h(App),
}).$mount('#app')